import { Injectable, NgZone, inject, signal } from "@angular/core";
import {
    Auth,
    GoogleAuthProvider,
    TwitterAuthProvider,
    createUserWithEmailAndPassword,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithPopup,
    signOut
} from "@angular/fire/auth";
import { Firestore, doc, setDoc } from "@angular/fire/firestore";
import { Router } from "@angular/router";

interface User {
    uid: string;
    email: string;
    displayName: string;
    photoURL: string;
    emailVerified: boolean;
}

@Injectable({ providedIn: "root" })
export class AuthService {

    private auth = inject(Auth);
    private firestore = inject(Firestore);
    private router = inject(Router);
    private ngZone = inject(NgZone);

    userData: any;
    authed = signal(false);

    constructor() {
        onAuthStateChanged(this.auth, user => {
            if (user && user.email === "denfordberriman@gmail.com") {
                this.userData = user;
                this.authed.set(true);
                localStorage.setItem("user", JSON.stringify(user));
            } else {
                this.authed.set(false);
                localStorage.setItem("user", "null");
            }
        });
    }

    setAuthed(val: boolean) {
        this.authed.set(val);
    }

    doTwitterLogin() {
        return signInWithPopup(this.auth, new TwitterAuthProvider());
    }

    doGoogleLogin() {
        const provider = new GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        return signInWithPopup(this.auth, provider)
            .then(result => {
                this.SetUserData(result.user);
                if (result.user.email === "denfordberriman@gmail.com") {
                    this.authed.set(true);
                }
                this.ngZone.run(() => this.router.navigate(["/"]));
            })
            .catch(error => window.alert(error));
    }

    doRegister(value: any) {
        return createUserWithEmailAndPassword(this.auth, value.email, value.password);
    }

    doLogin(value: any) {
        return signInWithEmailAndPassword(this.auth, value.email, value.password);
    }

    doLogout() {
        if (this.auth.currentUser) {
            return signOut(this.auth).then(() => {
                this.authed.set(false);
                this.router.navigate(["/"]);
            });
        } else {
            this.authed.set(false);
            this.router.navigate(["/"]);
            return Promise.resolve();
        }
    }

    get isLoggedIn(): boolean {
        const user = JSON.parse(localStorage.getItem("user") ?? "null");
        return user !== null && user.emailVerified !== false;
    }

    SetUserData(user: any) {
        const userRef = doc(this.firestore, `users/${user.uid}`);
        const userData: User = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            emailVerified: user.emailVerified
        };
        return setDoc(userRef, userData, { merge: true });
    }
}
